import api from '@app/api/api';

const controller = "crfacronimosagrupador";

export interface CrfAcronimoAgrupador {
  id: string;
  sigla: string;
  disciplinaId: string;
  tipoId: string;
  acronimoId: string;
}

export interface CrfAcronimoPlanilha {
  projetoId: string;
  revisao: number;
  numero: number;
  nome: string;
  id: string;
  numberIndex: number;
  dataAprovacao: string;
}

export const getAllAcronimosAgrupador = () => api.get<CrfAcronimoAgrupador[]>(controller);
export const getAllAcronimosAgrupadorOptions = () =>
  api.get<CrfAcronimoAgrupador[]>(controller)
    .then((values: any) => (values || []).map((v: any) => ({ text: v.sigla, value: v.id.toString() })));

export const createCrfAcronimoAgrupador = (acronimo: CrfAcronimoAgrupador) => api.post<CrfAcronimoAgrupador>(controller, acronimo);

export const updateCrfAcronimoAgrupador = (acronimo: CrfAcronimoAgrupador) => {
  return api
    .put<boolean>(`${controller}/${acronimo.id}`, acronimo)
    .then(result => true)
    .catch(err => false);
};

export const deleteCrfAcronimoAgrupador = (id: string) => api.delete(`${controller}/${id}`);
